import React from 'react';
import Swal from 'sweetalert2';
import authAxios from "../../services/Token";
import { DefaultLayout } from '../../layout/theme-customizer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel, faFilter, faSync } from '@fortawesome/free-solid-svg-icons';

class ReporteEducativo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            filtros: {
                programas: [],
                areas: [],
                cursos: [],
                materias: [],
                docentes: [],
                grupos: []
            },
            seleccion: {
                programa: '',
                area: '',
                curso: '',
                materia: '',
                docente: '',
                grupo: '',
                estudiante: ''
            },
            data: [],
            pagination: {
                current_page: 1,
                last_page: 1,
                total: 0
            },
            loading: false
        };
    }

    componentDidMount() {
        this.cargarFiltros();
        this.cargarReporte(1);
    }

    cargarFiltros = () => {
        authAxios.get("reporte/filtros")
            .then(res => {
                this.setState({ filtros: res.data });
            })
            .catch(err => console.error("Error cargando filtros", err));
    }

    cargarReporte = (page = 1) => {
        this.setState({ loading: true });
        Swal.showLoading();
        
        authAxios.post(`reporte/listar?page=${page}`, this.state.seleccion)
            .then(res => {
                Swal.close();
                this.setState({
                    data: res.data.data,
                    pagination: {
                        current_page: res.data.current_page,
                        last_page: res.data.last_page,
                        total: res.data.total
                    },
                    loading: false
                });
            })
            .catch(err => {
                Swal.close();
                this.setState({ loading: false });
                Swal.fire('Error', 'No se pudo cargar el reporte', 'error');
            });
    }

    handleFilterChange = (e) => {
        const { name, value } = e.target;
        this.setState(prevState => ({
            seleccion: {
                ...prevState.seleccion,
                [name]: value
            }
        }));
    }

    exportarExcel = () => {
        Swal.fire({
            title: 'Generando Excel...',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        authAxios.post("reporte/exportar", this.state.seleccion, { responseType: 'blob' })
            .then(res => {
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'reporte_educativo.xlsx');
                document.body.appendChild(link);
                link.click();
                Swal.close();
            })
            .catch(err => {
                Swal.close();
                Swal.fire('Error', 'No se pudo exportar el archivo', 'error');
            });
    }

    render() {
        const { filtros, seleccion, data, pagination, loading } = this.state;

        return (
            <div className="content">
                <div className="container-fluid">
                    <br />
                    <div className="card shadow-sm border-0" style={{ borderRadius: '15px', overflow: 'hidden' }}>
                        <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center py-3">
                            <h4 className="mb-0">Reporte General de Educación</h4>
                            <button className="btn btn-light btn-sm text-primary" onClick={this.exportarExcel}>
                                <FontAwesomeIcon icon={faFileExcel} className="me-2" />
                                Exportar a Excel
                            </button>
                        </div>
                        <div className="card-body bg-light">
                            <div className="row g-3">
                                <div className="col-md-3">
                                    <label className="form-label small fw-bold">Programa</label>
                                    <select className="form-select form-select-sm" name="programa" value={seleccion.programa} onChange={this.handleFilterChange}>
                                        <option value="">Todos los Programas</option>
                                        {filtros.programas.map(p => <option key={p.id} value={p.id}>{p.nombre}</option>)}
                                    </select>
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label small fw-bold">Área</label>
                                    <select className="form-select form-select-sm" name="area" value={seleccion.area} onChange={this.handleFilterChange}>
                                        <option value="">Todas las Áreas</option>
                                        {filtros.areas.filter(a => !seleccion.programa || a.programa == seleccion.programa).map(a => <option key={a.id} value={a.id}>{a.nombre}</option>)}
                                    </select>
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label small fw-bold">Curso</label>
                                    <select className="form-select form-select-sm" name="curso" value={seleccion.curso} onChange={this.handleFilterChange}>
                                        <option value="">Todos los Cursos</option>
                                        {filtros.cursos.filter(c => !seleccion.area || c.area == seleccion.area).map(c => <option key={c.id} value={c.id}>{c.nombre}</option>)}
                                    </select>
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label small fw-bold">Materia</label>
                                    <select className="form-select form-select-sm" name="materia" value={seleccion.materia} onChange={this.handleFilterChange}>
                                        <option value="">Todas las Materias</option>
                                        {filtros.materias.map(m => <option key={m.id} value={m.id}>{m.nombre}</option>)}
                                    </select>
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label small fw-bold">Docente</label>
                                    <select className="form-select form-select-sm" name="docente" value={seleccion.docente} onChange={this.handleFilterChange}>
                                        <option value="">Todos los Docentes</option>
                                        {filtros.docentes.map(d => <option key={d.id} value={d.id}>{d.nombre}</option>)}
                                    </select>
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label small fw-bold">Grupo</label>
                                    <select className="form-select form-select-sm" name="grupo" value={seleccion.grupo} onChange={this.handleFilterChange}>
                                        <option value="">Todos los Grupos</option>
                                        {filtros.grupos.filter(g => !seleccion.curso || g.curso == seleccion.curso).map(g => <option key={g.id} value={g.id}>{g.nombre}</option>)}
                                    </select>
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label small fw-bold">Estudiante (Nombre o Cédula)</label>
                                    <input type="text" className="form-control form-control-sm" name="estudiante" value={seleccion.estudiante} onChange={this.handleFilterChange} placeholder="Buscar por nombre o documento..." />
                                </div>
                                <div className="col-md-3 d-flex align-items-end">
                                    <button className="btn btn-primary btn-sm w-100" onClick={() => this.cargarReporte(1)}>
                                        <FontAwesomeIcon icon={faFilter} className="me-2" />
                                        Filtrar Reporte
                                    </button>
                                </div>
                            </div>

                            <div className="table-responsive mt-4 shadow-sm rounded">
                                <table className="table table-hover align-middle mb-0" style={{ fontSize: '0.9rem' }}>
                                    <thead className="table-dark">
                                        <tr>
                                            <th>Programa</th>
                                            <th>Curso</th>
                                            <th>Grupo</th>
                                            <th>Docente</th>
                                            <th>Materia</th>
                                            <th>Contenido</th>
                                            <th>Estudiante</th>
                                            <th>Nota</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.length > 0 ? (
                                            data.map((item, index) => (
                                                <tr key={index}>
                                                    <td><span className="badge bg-secondary">{item.programa}</span></td>
                                                    <td>{item.curso}</td>
                                                    <td>{item.grupo}</td>
                                                    <td>{item.docente}</td>
                                                    <td className="fw-bold">{item.materia}</td>
                                                    <td className="text-muted small">{item.contenido}</td>
                                                    <td>
                                                        <div>{item.estudiante}</div>
                                                        <div className="text-muted extra-small">{item.documento}</div>
                                                    </td>
                                                    <td>
                                                        <span className={`badge ${item.nota >= 3 ? 'bg-success' : 'bg-danger'}`}>
                                                            {item.nota || 'N/A'}
                                                        </span>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="8" className="text-center py-4 text-muted">No se encontraron registros</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="card-footer bg-white d-flex justify-content-between align-items-center py-3">
                            <div className="small text-muted">
                                Mostrando <strong>{data.length}</strong> de <strong>{pagination.total}</strong> registros
                            </div>
                            <nav aria-label="Page navigation">
                                <ul className="pagination pagination-sm mb-0">
                                    <li className={`page-item ${pagination.current_page === 1 ? 'disabled' : ''}`}>
                                        <button className="page-link" onClick={() => this.cargarReporte(1)}>{"<<"}</button>
                                    </li>
                                    <li className={`page-item ${pagination.current_page === 1 ? 'disabled' : ''}`}>
                                        <button className="page-link" onClick={() => this.cargarReporte(pagination.current_page - 1)}>{"<"}</button>
                                    </li>
                                    <li className="page-item active">
                                        <span className="page-link">{pagination.current_page}</span>
                                    </li>
                                    <li className={`page-item ${pagination.current_page === pagination.last_page ? 'disabled' : ''}`}>
                                        <button className="page-link" onClick={() => this.cargarReporte(pagination.current_page + 1)}>{">"}</button>
                                    </li>
                                    <li className={`page-item ${pagination.current_page === pagination.last_page ? 'disabled' : ''}`}>
                                        <button className="page-link" onClick={() => this.cargarReporte(pagination.last_page)}>{">>"}</button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ReporteEducativo;